import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { AsyncPipe } from '@angular/common';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormLabelComponent } from '../../_core/form-label/form-label.component';
import { ShFormSelectBaseComponent } from '../../form-select/base/form-select-base.component';
import { ShFormEDTFComplexBaseComponent } from '../base-complex/form-edtf-complex-base.component';

@Component({
    selector: 'sh-form-edtf-base',
    templateUrl: '../base-complex/form-edtf-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormEDTFBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, ShFormLabelComponent, ShFormSelectBaseComponent, AsyncPipe]
})
export class ShFormEDTFBaseComponent extends ShFormEDTFComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
        super(changeDetectorRef, formBuilder);
    }

    propagateChange(formValue: FormValue<string>): void {
        super.propagateSimpleChange(FormValue.unwrap(formValue));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
